var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KTTable',{attrs:{"title":"Borme","subtitle":"Movimientos Borme","showOnly":true,"fields":_vm.fields,"endpoint":_vm.endpoint,"responsive":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }